export default [
  {
    path: `/ui-instructions`,
    name: `ui-instructions`,
    component: () => import('./views/instructions.vue'),
    meta: {
      title: 'Инструкции',
      layout: 'ui-design',
    },
  },
];
